import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3333 21.3333C15.3333 23.9106 13.244 25.9999 10.6667 25.9999C8.08934 25.9999 6 23.9106 6 21.3333C6 18.7559 8.08934 16.6666 10.6667 16.6666C13.244 16.6666 15.3333 18.7559 15.3333 21.3333ZM15.3333 21.3333C15.3333 18.2974 13.3333 15.9812 13.3333 11.9999C13.3333 8.01862 16.5812 5.33325 20 5.33325C23.344 5.33325 26.6667 8.02534 26.6667 11.9999C26.6667 17.2141 20 21.5956 20 25.9999C20 29.4619 22.31 30.6666 24 30.6666C25.69 30.6666 27.4209 29.5482 28 28.3999",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLeo;
